import { Modal, Space } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import CaseTimeline from "./CaseTimeline";

type Props = {
  id?: string;
  number?: string;
  visible: boolean;
  setVisible: (visible: boolean) => void;
};

/**
 * The case's own story, where the Audit Trail dialog used to be.
 *
 * Same entry point on purpose. "Audit Trail" is where people already went
 * looking for "what happened here", and they left again having found only
 * half of it — the status moves, without the comments, the section
 * submissions or which duty each signature discharged. Adding a *second*
 * dialog beside it would leave two places to look for one answer, which is the
 * problem, not the fix.
 *
 * ``AuditTrailModal`` is kept for now because the field PWA still renders it;
 * this replaces it in the desktop app only.
 */
const CaseTimelineModal = ({ id, number, visible, setVisible }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={
        <Space size={10} align="center">
          <HistoryOutlined style={{ fontSize: 18 }} />
          <span style={{ fontSize: 16, fontWeight: 600 }}>
            {t("What happened here")}
          </span>
          {number && (
            <span style={{ fontSize: 13, fontWeight: 400, opacity: 0.65 }}>
              {number}
            </span>
          )}
        </Space>
      }
      open={visible}
      onCancel={() => setVisible(false)}
      footer={null}
      centered
      width={660}
      styles={{ body: { paddingTop: 16, maxHeight: "62vh", overflowY: "auto" } }}
      // Unmounted when closed, so reopening it re-reads rather than showing the
      // story as it stood the first time somebody looked.
      destroyOnClose
    >
      {id && <CaseTimeline requestId={id} />}
    </Modal>
  );
};

export default CaseTimelineModal;
